export default {
  "b2b.projekt-vytvoreni.title.vytvoreni": "Nový projekt",
  "b2b.projekt-vytvoreni.title.edit": "Editace projektu",
  "b2b.projekt-vytvoreni.field.nazev.label": "Název",
  "b2b.projekt-vytvoreni.field.nazevEn.label": "Název en",
  "b2b.projekt-vytvoreni.field.popis.label": "Popis",
  "b2b.projekt-vytvoreni.field.popisEn.label": "Popis en",
  "b2b.projekt-vytvoreni.button.submit-vytvoreni": "Založit",
  "b2b.projekt-vytvoreni.button.submit-edit": "Uložit",
  "b2b.projekt-vytvoreni.button.cancel": "Zrušit",
  "b2b.projekt-vytvoreni.save-dialog.title": "Uložení projektu"
};
